import React from 'react';
import {
  FrasesContainer,
  FrasesTitle,
  ImageContainer,
  TitleLeftPanel,
} from './left-panel-content-style';

import { FraseItem } from '../accortion-informations/accortion-informations-style';

import {
  MODULE_IMAGES,
  STEP_TEXTS,
  STEP_TEXTS_STARTUP,
} from '../../constants/interview-data';

export const LeftPanelContent = ({
  interview,
  currentStep,
  activeQuestionId,
  currentFrases,
  showTips = false,
}) => {
  const isStartup = interview?.module?.id === 2;
  const textColor = !isStartup ? '#fff' : '#000';
  const stepText = !isStartup
    ? STEP_TEXTS[currentStep]
    : STEP_TEXTS_STARTUP[currentStep];
  const candidateFirstName = interview?.candidate?.name?.split(' ')[0];

  if (showTips && !isStartup && currentStep === 5) {
    return (
      <FrasesContainer>
        <FrasesTitle>Dicas para Pergunta {activeQuestionId}</FrasesTitle>
        {currentFrases.map((frase, index) => (
          <FraseItem key={index}>{frase}</FraseItem>
        ))}
      </FrasesContainer>
    );
  }

  return (
    <>
      <TitleLeftPanel color={textColor}>
        Olá, <strong>{candidateFirstName}</strong>! {stepText}
      </TitleLeftPanel>
      <ImageContainer>
        <img
          src={MODULE_IMAGES[interview?.module?.id]}
          alt="imagem representando o empretec"
        />
      </ImageContainer>
    </>
  );
};
